import { isNull } from 'lodash'

/**
 * Converts a value in cents to a formatted string in dollars.
 * If the input is null, it returns '0.00'.
 *
 * @param {number} num - The value in cents.
 * @returns {string | undefined} The value in dollars formatted to two decimal places, or undefined if the input is not a number.
 */
export const fromCents = (num: number): string | undefined => {
  if (isNull(num)) {
    return (0).toFixed(2)
  }
  if (!isNaN(num)) {
    return (num / 100).toFixed(2)
  }
}

/**
 * Converts a value in dollars to cents.
 * If the input is null, it returns 0.
 *
 * @param {number} num - The value in dollars.
 * @returns {number | undefined} The value in cents, or undefined if the input is not a number.
 */
export const toCents = (num: number): number | undefined => {
  if (isNull(num)) {
    return 0
  }
  if (!isNaN(num)) {
    return num * 100
  }
}
